'use client';

import { useState } from 'react';
import styles from './ReviewSection.module.css';

interface ReviewSectionProps {
  children: React.ReactNode;
  initialVisibleCount?: number;
  totalCount: number;
  showAllText: string;
  showLessText: string;
}

export function ReviewSection({
  children,
  initialVisibleCount = 6,
  totalCount,
  showAllText,
  showLessText,
}: ReviewSectionProps) {
  const [showAll, setShowAll] = useState(false);
  const shouldShowButton = totalCount > initialVisibleCount;

  return (
    <>
      <div className={styles.reviewGrid} data-show-all={showAll}>
        {children}
      </div>
      
      {shouldShowButton && (
        <div className={styles.buttonWrapper}>
          <button
            onClick={() => setShowAll(!showAll)}
            className={styles.showAllButton}
          >
            {showAll ? showLessText : showAllText}
          </button>
        </div>
      )}
    </>
  );
}

